import styles from './provinceSelector.module.css'
import { Badge } from '../badge/badge'
import { FieldType } from '../types'
import { Option } from '../types'
import { SelectField } from '../fields/select-field/selectField'
import { StaticValue } from '../static-value/staticValue'

type Props = {
    provinces: string[]
    options: Option[]
    readOnly?: boolean
    emptyMessage?: string
    onAdd?: (province: string) => void
    onRemove?: (province: string) => void
}

export const ProvinceSelector = (props: Props) => {
    const { provinces, options, readOnly = false, emptyMessage, onAdd, onRemove } = props
    const availableOptions = options.filter(option => !provinces.includes(option.value))

    if (readOnly) {
        return provinces.length === 0 && emptyMessage
            ? <StaticValue type={FieldType.TEXT} value={emptyMessage} />
            : <div className={styles.chips}>
                {provinces.map(province => <Badge key={province} label={province} kind="secondary" small />)}
            </div>
    }

    return (
        <div className={styles.editor}>
            <SelectField
                id="addProvince"
                value={undefined}
                options={availableOptions}
                onChange={value => value && onAdd?.(value)}
                className={styles.select}
            />
            {provinces.length > 0 ? (
                <div className={styles.chips}>
                    {provinces.map(province => (
                        <Badge
                            key={province}
                            label={province}
                            kind="secondary"
                            small
                            icon="x"
                            className={styles.removeBadge}
                            onClick={() => onRemove?.(province)}
                        />
                    ))}
                </div>
            ) : emptyMessage ? <StaticValue type={FieldType.TEXT} value={emptyMessage} /> : null}
        </div>
    )
}
